module.exports = __webpack_public_path__ + "images/emoji/stew.2a08a5b04b1f004fe544.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/stew.png
// module id = w+nN
// module chunks = 14